var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#808080",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1276 14.303C18.1276 15.9882 16.7746 17.3534 15.0893 17.3594H15.0833H9.09726C7.41804 17.3594 6.04688 16.0003 6.04688 14.3151V14.309C6.04688 14.309 6.0505 11.6356 6.05533 10.291C6.05594 10.0385 6.34587 9.89715 6.54339 10.0542C7.97858 11.1928 10.5451 13.2689 10.5771 13.2961C11.006 13.6398 11.5496 13.8337 12.1054 13.8337C12.6611 13.8337 13.2047 13.6398 13.6336 13.2894C13.6656 13.2683 16.1747 11.2544 17.6317 10.0971C17.8298 9.93943 18.121 10.0808 18.1216 10.3327C18.1276 11.667 18.1276 14.303 18.1276 14.303Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8119 8.10152C17.2888 7.11573 16.2595 6.48633 15.1264 6.48633H9.09809C7.96491 6.48633 6.93564 7.11573 6.41254 8.10152C6.29536 8.32199 6.35093 8.59683 6.54603 8.75267L11.031 12.34C11.3451 12.5937 11.7256 12.72 12.1062 12.72C12.1086 12.72 12.1104 12.72 12.1122 12.72C12.114 12.72 12.1165 12.72 12.1183 12.72C12.4988 12.72 12.8794 12.5937 13.1934 12.34L17.6784 8.75267C17.8735 8.59683 17.9291 8.32199 17.8119 8.10152Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemail);
export default __webpack_public_path__ + "static/media/Demail.b52afc8fde8c0786d49b3ac124e46d6e.svg";
export { ForwardRef as ReactComponent };